<div class="d-flex flex-column h-100">
  <mat-progress-bar mode="indeterminate"
    *ngIf="!showError"></mat-progress-bar>
  <div class="container-fluid d-flex flex-column flex-grow-1">
    <div class="m-auto">
      <h1 class="text-capitalize aboca-primary-color title">{{'META_TAGS.DEFAULT_TITLE' | translate}}</h1>
      <h2 [ngClass]="{invisible: !showError}">{{'SIGNIN.ERROR' | translate}}</h2>
    </div>
  </div>
</div>